export default __webpack_public_path__ + "static/media/Photodigm.786d04ca.png";